module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Add sensors to view this parameter.","subtitle":"Edit the section and add sensors to see the data","addSectionBtn":"Edit the Section"},"it":{"title":"Non hai configurato questa Sezione.","subtitle":"Modifica la Sezione e aggiungi dei sensori per poter visualizzare i dati.","addSectionBtn":"Modifica la Sezione"}}')
  delete Component.options._Ctor
}
